<template>
  <div class="notification-panel" :class="{ full }">
    <Transition name="fade" @after-leave="$emit('changeAlert')">
      <Component :is="alertComponent" :key="alertComponent" :full="full" />
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NothingVerified from '@/components/NotificationPanel/Alerts/NothingVerified'
import SetLimits from '@/components/NotificationPanel/Alerts/SetLimits'

export default {
  name: 'NotificationPanel',
  components: {
    NothingVerified,
    SetLimits,
  },
  props: {
    full: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('user', [
      'isUserVerified',
      'isUserSomethingVerified',
    ]),
    ...mapGetters('limits', ['get_isLimitsHasBeenSet']),
    ...mapGetters('promotions', ['get_bonusesListTriggered']),
    alertComponent() {
      if (!this.isUserVerified) {
        return 'NothingVerified'
      }
      else if (this.isUserVerified && !this.get_isLimitsHasBeenSet) {
        return 'SetLimits'
      }
      else return null
    },
  },
}
</script>

<style lang="scss" scoped src="./style.scss" />
